"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_1 = __importDefault(require("../../styled"));
var text_1 = require("../../atoms/text");
var tokens_1 = require("../../tokens");
var automation_attribute_1 = __importDefault(require("../../_helpers/automation-attribute"));
var Label = function (props) { return (React.createElement(Label.Element, __assign({}, automation_attribute_1.default('label'), props), props.children)); };
Label.Element = styled_1.default(text_1.StyledTextAllCaps)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 11px;\n  color: ", ";\n  padding: 2px 6px;\n  border: 1px solid ", ";\n  border-radius: ", ";\n  line-height: 1.2;\n"], ["\n  font-size: 11px;\n  color: ", ";\n  padding: 2px 6px;\n  border: 1px solid ", ";\n  border-radius: ", ";\n  line-height: 1.2;\n"])), function (props) { return tokens_1.colors.status[props.appearance]; }, function (props) { return tokens_1.colors.status[props.appearance]; }, tokens_1.misc.radius);
var StyledLabel = Label.Element;
exports.StyledLabel = StyledLabel;
Label.defaultProps = {
    appearance: 'default'
};
exports.default = Label;
var templateObject_1;
//# sourceMappingURL=label.js.map